import React from "react";
import Select from "react-select";

const RoleModal = ({
  isOpen,
  onClose,
  roleForm,
  setRoleForm,
  permissionRows,
  addNewRow,
  removeRow,
  updateRow,
  modules,
  permissions,
  onSave,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlays" onClick={onClose}>
      <div
        className="modals"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: "680px" }}
      >
        <div className="modals-header">
          <h2>Create Role</h2>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div
          className="form-group"
          style={{ padding: "0 24px", marginTop: "24px" }}
        >
          <label>
            Role Name <span className="required">*</span>
          </label>
          <input
            type="text"
            value={roleForm.name}
            onChange={(e) => setRoleForm({ ...roleForm, name: e.target.value })}
            placeholder="e.g. Manager"
          />
        </div>

        <div className="form-group" style={{ padding: "0 24px" }}>
          <label>Description (optional)</label>
          <textarea
            rows={3}
            value={roleForm.description}
            onChange={(e) =>
              setRoleForm({ ...roleForm, description: e.target.value })
            }
            placeholder="Role responsibilities"
          />
        </div>

        <div className="form-group" style={{ padding: "0 24px" }}>
          <label>Permissions</label>
          <div
            style={{
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              padding: "16px",
              background: "#f9fafb",
              maxHeight: "300px",
              overflowY: "auto",
            }}
          >
            {permissionRows.map((row, index) => (
              <div
                key={row.id}
                style={{
                  display: "flex",
                  gap: "12px",
                  alignItems: "flex-start",
                  marginBottom: "16px",
                  padding: "12px",
                  background: "white",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                }}
              >
                <div style={{ flex: "1" }}>
                  <label
                    style={{
                      fontSize: "12px",
                      color: "#6b7280",
                      marginBottom: "4px",
                      display: "block",
                    }}
                  >
                    Module
                  </label>
                  <Select
                    options={modules
                      .filter(
                        (m) =>
                          !permissionRows.some(
                            (r, i) => i !== index && r.moduleId === m.id,
                          ),
                      )
                      .map((m) => ({ value: m.id, label: m.name }))}
                    value={
                      row.moduleId
                        ? {
                            value: row.moduleId,
                            label:
                              modules.find((m) => m.id === row.moduleId)
                                ?.name || "",
                          }
                        : null
                    }
                    onChange={(opt) =>
                      updateRow(index, {
                        moduleId: opt?.value || null,
                        permissionIds: [],
                      })
                    }
                    placeholder="Select..."
                    isClearable
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </div>

                <div style={{ flex: "2" }}>
                  <label
                    style={{
                      fontSize: "12px",
                      color: "#6b7280",
                      marginBottom: "4px",
                      display: "block",
                    }}
                  >
                    Permissions
                  </label>
                  <Select
                    isMulti
                    isDisabled={!row.moduleId}
                    options={
                      row.moduleId
                        ? permissions.map((p) => ({
                            value: p.id,
                            label: p.action || `Permission ${p.id}`,
                          }))
                        : []
                    }
                    value={row.permissionIds
                      .map((id) => {
                        const perm = permissions.find((p) => p.id === id);
                        return perm
                          ? { value: perm.id, label: perm.action }
                          : null;
                      })
                      .filter(Boolean)}
                    onChange={(selected) =>
                      updateRow(index, {
                        permissionIds: selected
                          ? selected.map((opt) => opt.value)
                          : [],
                      })
                    }
                    placeholder="Select..."
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </div>

                <button
                  type="button"
                  onClick={() => removeRow(index)}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#ef4444",
                    fontSize: "20px",
                    cursor: "pointer",
                    marginTop: "24px",
                  }}
                >
                  ×
                </button>
              </div>
            ))}

            <button
              type="button"
              className="link-btn"
              onClick={addNewRow}
              disabled={permissionRows.length >= modules.length}
            >
              + Add Module & Permissions
            </button>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={onSave}
            disabled={
              !roleForm.name.trim() ||
              permissionRows.every(
                (r) => !r.moduleId || r.permissionIds.length === 0,
              )
            }
          >
            Create Role
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoleModal;
